import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import t from "../../core/Evented.js";
import { HandleOwner as i } from "../../core/HandleOwner.js";
import { clone as r } from "../../core/lang.js";
import { isNone as s, destroyMaybe as n, removeMaybe as a, isSome as o, abortMaybe as p } from "../../core/maybe.js";
import { createTask as h } from "../../core/promiseUtils.js";
import { createScreenPoint as c } from "../../core/screenUtils.js";
import { property as d } from "../../core/accessorSupport/decorators/property.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as l } from "../../core/accessorSupport/decorators/subclass.js";
import { pointEquals as m } from "../../layers/graphics/dehydratedFeatureComparison.js";
import { DrawManipulator as g } from "./DrawManipulator.js";
import { defaultDrawingMode as u } from "./DrawingMode.js";
import { createCoordinateHelper as y } from "../interactive/coordinateHelper.js";
import { createManipulatorDragEventPipeline as v } from "../interactive/dragEventPipeline.js";
import { EditGeometry as _, Component as x } from "../interactive/editGeometry/EditGeometry.js";
import { EditGeometryOperations as f } from "../interactive/editGeometry/EditGeometryOperations.js";
import { SnappingContext as T } from "../interactive/snapping/SnappingContext.js";
import { SnappingPipeline as V } from "../interactive/snapping/SnappingDragPipelineStep.js";
import { TaskPriority as S, ImmediateTask as w } from "../support/Scheduler.js";

var M = /*#__PURE__*/function (_t$EventedMixin) {
  _inherits(M, _t$EventedMixin);

  var _super = _createSuper(M);

  function M(e) {
    var _this;

    _classCallCheck(this, M);

    _this = _super.call(this, e), _this._createOperationCompleted = !1, _this._pointerDownStates = new Set(), _this._snappingPipeline = new V(), _this._snappingTask = null, _this._stagedVertex = null, _this.snapToSceneEnabled = null, s(e.elevationInfo) && (_this.elevationInfo = {
      mode: e.hasZ ? "absolute-height" : "on-the-ground",
      offset: 0
    });
    return _this;
  }

  _createClass(M, [{
    key: "initialize",
    value: function initialize() {
      var _this2 = this;

      var e, t;
      this.coordinateHelper = y(this.hasZ, this.hasM, this.view.spatialReference);
      var i = "3d" === this.view.type ? null == (e = this.view) || null == (t = e.resourceController) ? void 0 : t.scheduler : null;
      this._frameTask = i ? i.registerTask(S.SNAPPING) : w;
      var r = "viewingMode" in this.view.state ? this.view.state.viewingMode : 2,
          s = "segment" === this.geometryType || "multipoint" === this.geometryType ? "polyline" : this.geometryType;
      this._editGeometryOperations = new f(new _(s, this.coordinateHelper, r)), this._activeComponent = new x(this.spatialReference, r), this._editGeometryOperations.data.components.push(this._activeComponent), this.handles.add(this._editGeometryOperations.on(["vertex-add", "vertex-update", "vertex-remove"], function (e) {
        var t = e.vertices.map(function (e) {
          return {
            componentIndex: 0,
            vertexIndex: e.index,
            coordinates: _this2.coordinateHelper.vectorToArray(e.pos)
          };
        }),
            i = t.map(function (e) {
          return e.coordinates;
        });

        switch (e.type) {
          case "vertex-add":
            _this2.emit(e.type, _objectSpread(_objectSpread({}, e), {}, {
              added: i,
              vertices: t
            }));

            break;

          case "vertex-update":
            _this2.emit(e.type, _objectSpread(_objectSpread({}, e), {}, {
              updated: i,
              vertices: t
            }));

            break;

          case "vertex-remove":
            _this2.emit(e.type, _objectSpread(_objectSpread({}, e), {}, {
              removed: i,
              vertices: t
            }));

        }
      })), this._manipulator = new g({
        grabbableForEvent: function grabbableForEvent(e) {
          return "click" !== _this2.drawingMode || "touch" === e.pointerType && _this2._snappingEnabled && 1 === _this2._pointerDownStates.size;
        }
      }), this.manipulators.add(this._manipulator), this._manipulator.grabbable = "point" !== this.geometryType, this.handles.add([this._createManipulatorDragPipeline(this._manipulator), this._manipulator.events.on("immediate-click", function (e) {
        return _this2._onImmediateClick(e);
      }), this._manipulator.events.on("immediate-double-click", function (e) {
        return _this2._onImmediateDoubleClick(e);
      })]);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._editGeometryOperations = n(this._editGeometryOperations), this._frameTask = a(this._frameTask);
    }
  }, {
    key: "_snappingEnabled",
    get: function get() {
      return o(this.snappingManager) && this.snappingManager.options.effectiveEnabled;
    }
  }, {
    key: "canRedo",
    get: function get() {
      return this._editGeometryOperations.canRedo;
    }
  }, {
    key: "canUndo",
    get: function get() {
      return this._editGeometryOperations.canUndo;
    }
  }, {
    key: "committedVertices",
    get: function get() {
      var _this3 = this;

      return this._activeComponent.vertices.map(function (e) {
        return _this3.coordinateHelper.vectorToArray(e.pos);
      });
    }
  }, {
    key: "drawingMode",
    set: function set(e) {
      this._set("drawingMode", null != e ? e : u);
    }
  }, {
    key: "hasStagedVertex",
    get: function get() {
      return o(this._stagedVertex);
    }
  }, {
    key: "interactive",
    get: function get() {
      return this._manipulator.interactive;
    },
    set: function set(e) {
      this._manipulator.interactive = e;
    }
  }, {
    key: "isCompleted",
    get: function get() {
      return this._createOperationCompleted;
    }
  }, {
    key: "numCommittedVertices",
    get: function get() {
      return this._activeComponent.vertices.length;
    }
  }, {
    key: "numVertices",
    get: function get() {
      return o(this._stagedVertex) ? this._activeComponent.vertices.length + 1 : this._activeComponent.vertices.length;
    }
  }, {
    key: "spatialReference",
    get: function get() {
      return this.view.spatialReference;
    }
  }, {
    key: "stagedVertex",
    get: function get() {
      return this._stagedVertex;
    },
    set: function set(e) {
      if (s(e)) this.discardStagedVertex();else if (!o(this._stagedVertex) || !m(this._stagedVertex, e)) {
        if (s(this._stagedVertex)) this._stagedVertex = r(e);else {
          if (m(this._stagedVertex, e)) return;
          this._stagedVertex.x = e.x, this._stagedVertex.y = e.y, this._stagedVertex.z = e.z, this._stagedVertex.m = e.m, this._stagedVertex.hasZ = e.hasZ, this._stagedVertex.hasM = e.hasM, this._stagedVertex.spatialReference = e.spatialReference;
        }
        this.emit("cursor-update", {
          updated: null,
          vertices: [{
            componentIndex: 0,
            vertexIndex: this._activeComponent.vertices.length,
            coordinates: this.coordinateHelper.pointToArray(e)
          }],
          operation: "apply",
          type: "vertex-update"
        });
      }
    }
  }, {
    key: "updating",
    get: function get() {
      return this.updatingHandles.updating;
    }
  }, {
    key: "vertices",
    get: function get() {
      var e = this.committedVertices;
      return o(this._stagedVertex) && e.push(this.coordinateHelper.pointToArray(this._stagedVertex)), e;
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.complete({
        aborted: !0
      });
    }
  }, {
    key: "commitStagedVertex",
    value: function commitStagedVertex() {
      if (this._snappingTask = p(this._snappingTask), o(this._stagedVertex)) {
        var _e = this._stagedVertex;
        this._stagedVertex = null, this._editGeometryOperations.appendVertex(this.coordinateHelper.pointToVector(_e));
      }
    }
  }, {
    key: "complete",
    value: function complete(e) {
      var t = e && e.aborted || !1;
      p(this._snappingTask), o(this.snappingManager) && this.snappingManager.doneSnapping(), "segment" === this.geometryType || "point" === this.geometryType ? this.commitStagedVertex() : this.discardStagedVertex();
      var i = "multipoint" === this.geometryType && 0 === this.numVertices || "polyline" === this.geometryType && this.numVertices < 2 || "polygon" === this.geometryType && this.numVertices < 3;
      this._createOperationCompleted = !i, (this.isCompleted || t) && this.emit("complete", {
        vertices: this.vertices.map(function (e, t) {
          return {
            componentIndex: 0,
            vertexIndex: t,
            coordinates: e
          };
        }),
        aborted: t,
        type: "complete"
      });
    }
  }, {
    key: "discardStagedVertex",
    value: function discardStagedVertex() {
      this._stagedVertex = null;
    }
  }, {
    key: "onInputEvent",
    value: function onInputEvent(e) {
      switch (e.type) {
        case "pointer-down":
          this._pointerDownStates.add(e.pointerId);

          break;

        case "pointer-up":
          this._pointerDownStates.delete(e.pointerId);

      }

      switch (e.type) {
        case "pointer-move":
          return this._onPointerMove(e);

        case "hold":
          return this._onHold(e);
      }
    }
  }, {
    key: "redo",
    value: function redo() {
      this._editGeometryOperations.redo();
    }
  }, {
    key: "undo",
    value: function undo() {
      o(this.snappingManager) && this.snappingManager.doneSnapping(), this._editGeometryOperations.undo();
    }
  }, {
    key: "_closeOnClickVertexIndex",
    value: function _closeOnClickVertexIndex(e) {
      var t = this._activeComponent;

      if ("polygon" === this.geometryType && t.vertices.length > 2) {
        if (this._vertexWithinPointerDistance(t.vertices[0].pos, e)) return 0;
        if (this._vertexWithinPointerDistance(t.vertices[t.vertices.length - 1].pos, e)) return t.vertices.length - 1;
      }

      return null;
    }
  }, {
    key: "_createManipulatorDragPipeline",
    value: function _createManipulatorDragPipeline(e) {
      switch (this.drawingMode) {
        case "click":
          return this._createManipulatorDragPipelineClick(e);

        case "freehand":
          return this._createManipulatorDragPipelineFreehand(e);

        case "hybrid":
          return this._createManipulatorDragPipelineHybrid(e);
      }
    }
  }, {
    key: "_createManipulatorDragPipelineClick",
    value: function _createManipulatorDragPipelineClick(e) {
      var _this4 = this;

      return v(e, function (e, t, i, r) {
        var s = "touch" === r && _this4._snappingEnabled;
        !_this4.isCompleted && s && (t.next(_this4._screenToMapDragEventStep()).next(function (e) {
          return "start" === e.action && (_this4.stagedVertex = e.mapStart, ("segment" === _this4.geometryType || s && 0 === _this4.numVertices) && _this4.commitStagedVertex()), e;
        }).next(_this4._snappingPipeline.createSnapDragEventPipelineStep({
          predicate: function predicate() {
            return s;
          },
          cancel: i,
          snappingManager: _this4.snappingManager,
          snappingContext: new T({
            editGeometryOperations: _this4._editGeometryOperations,
            elevationInfo: _this4.elevationInfo,
            pointer: r,
            visualizer: _this4.snappingVisualizer
          }),
          updatingHandles: _this4.updatingHandles
        }), _this4._snappingPipeline.next).next(function (e) {
          return s && (_this4.stagedVertex = e.mapEnd, "end" === e.action && _this4.commitStagedVertex()), e;
        }).next(function (e) {
          return "end" === e.action && ("segment" !== _this4.geometryType && "point" !== _this4.geometryType || _this4.complete()), e;
        }), i.next(function () {
          s && o(_this4.snappingManager) && _this4.snappingManager.doneSnapping();
        }));
      });
    }
  }, {
    key: "_createManipulatorDragPipelineFreehand",
    value: function _createManipulatorDragPipelineFreehand(e) {
      var _this5 = this;

      return v(e, function (e, t) {
        _this5.isCompleted || t.next(_this5._screenToMapDragEventStep()).next(function (e) {
          return "start" === e.action && (s(_this5.stagedVertex) && (_this5.stagedVertex = e.mapStart), "segment" === _this5.geometryType && _this5.commitStagedVertex()), e;
        }).next(function (e) {
          switch (e.action) {
            case "start":
            case "update":
              _this5.stagedVertex = e.mapEnd, "polygon" !== _this5.geometryType && "polyline" !== _this5.geometryType || _this5.commitStagedVertex();
              break;

            case "end":
              _this5.complete();

          }

          return e;
        });
      });
    }
  }, {
    key: "_createManipulatorDragPipelineHybrid",
    value: function _createManipulatorDragPipelineHybrid(e) {
      var _this6 = this;

      return v(e, function (e, t) {
        _this6.isCompleted || t.next(_this6._screenToMapDragEventStep()).next(function (e) {
          return "start" === e.action && (s(_this6.stagedVertex) && (_this6.stagedVertex = e.mapStart), _this6.commitStagedVertex()), e;
        }).next(function (e) {
          switch (e.action) {
            case "start":
            case "update":
              _this6.stagedVertex = e.mapEnd, "polygon" !== _this6.geometryType && "polyline" !== _this6.geometryType || _this6.commitStagedVertex();
              break;

            case "end":
              "segment" !== _this6.geometryType && "point" !== _this6.geometryType || _this6.complete();
          }

          return e;
        });
      });
    }
  }, {
    key: "_getDrawSurface",
    value: function _getDrawSurface() {
      if (s(this.elevationDrawSurface)) return this.drawSurface;
      if (!this.coordinateHelper.hasZ) return this.elevationDrawSurface.defaultZ = null, this.elevationDrawSurface;
      var e = this.defaultZ,
          t = !1;
      o(this.elevationInfo) && "absolute-height" === this.elevationInfo.mode && (t = !0), o(this.snapToSceneEnabled) && (t = this.snapToSceneEnabled), o(this.elevationInfo) && "on-the-ground" === this.elevationInfo.mode && (t = !1);
      var i = this._activeComponent.vertices.length;
      return ("segment" === this.geometryType || "polygon" === this.geometryType) && i > 0 && (e = this.coordinateHelper.getZ(this._activeComponent.vertices[0].pos), t = !1), t ? this.drawSurface : (this.elevationDrawSurface.defaultZ = e, this.elevationDrawSurface);
    }
  }, {
    key: "_mapToScreen",
    value: function _mapToScreen(e) {
      return this._getDrawSurface().mapToScreen(e);
    }
  }, {
    key: "_onHold",
    value: function _onHold(e) {
      p(this._snappingTask), "click" === this.drawingMode && "touch" === e.pointerType && this._snappingEnabled && (this.stagedVertex = e.mapPoint), e.stopPropagation();
    }
  }, {
    key: "_onImmediateClick",
    value: function _onImmediateClick(e) {
      if ("mouse" === e.pointerType && 2 === e.button || this._manipulator.dragging) return;

      var t = this._activeComponent,
          i = this._closeOnClickVertexIndex(e.screenPoint);

      if (o(i)) return e.stopPropagation(), this.discardStagedVertex(), void this.complete();

      var r = this._screenToMap(e.screenPoint);

      if (o(r)) switch (this.drawingMode) {
        case "freehand":
          "point" === this.geometryType && (this.hasStagedVertex ? this.commitStagedVertex() : this._editGeometryOperations.appendVertex(this.coordinateHelper.pointToVector(r)), this.complete());
          break;

        case "click":
        case "hybrid":
          this._snappingTask = p(this._snappingTask), this.hasStagedVertex ? this.commitStagedVertex() : this._editGeometryOperations.appendVertex(this.coordinateHelper.pointToVector(r)), ("point" === this.geometryType || "segment" === this.geometryType && 2 === t.vertices.length || "segment" === this.geometryType && "hybrid" === this.drawingMode && 1 === t.vertices.length) && this.complete();
      }
      e.stopPropagation();
    }
  }, {
    key: "_onImmediateDoubleClick",
    value: function _onImmediateDoubleClick(e) {
      this._manipulator.dragging || "point" === this.geometryType || (this.complete(), e.stopPropagation());
    }
  }, {
    key: "_onPointerMove",
    value: function _onPointerMove(e) {
      var _this7 = this;

      if (p(this._snappingTask), this._manipulator.dragging || this._pointerDownStates.has(e.pointerId) || this._manipulator.grabbing || !this._manipulator.interactive) return;

      var t = c(e.x, e.y),
          i = this._closeOnClickVertexIndex(t);

      if (o(i)) {
        this.discardStagedVertex();
        var _e2 = {
          componentIndex: 0,
          vertexIndex: i,
          coordinates: this.coordinateHelper.vectorToArray(this._activeComponent.vertices[i].pos)
        };
        this.emit("cursor-update", {
          updated: null,
          vertices: [_e2],
          operation: "apply",
          type: "vertex-update"
        });
      } else {
        var _i = this._screenToMap(t);

        if (this._manipulator.cursor = o(_i) ? "crosshair" : null, o(_i)) if (o(this.snappingManager)) {
          var _t = this.snappingManager,
              _r = new T({
            editGeometryOperations: this._editGeometryOperations,
            elevationInfo: this.elevationInfo,
            pointer: e.pointerType,
            visualizer: this.snappingVisualizer
          });

          this.stagedVertex = _t.update(_i, _r), this._snappingTask = h( /*#__PURE__*/function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
              var s;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return _this7._frameTask.schedule(function () {
                        return _t.snap(_i, _r, e);
                      }, e);

                    case 2:
                      s = _context.sent;
                      _context.t0 = s.valid;

                      if (!_context.t0) {
                        _context.next = 7;
                        break;
                      }

                      _context.next = 7;
                      return _this7._frameTask.schedule(function () {
                        _this7.stagedVertex = s.apply();
                      }, e);

                    case 7:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }));

            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }()), this.updatingHandles.addPromise(this._snappingTask.promise);
        } else this.stagedVertex = _i;
      }

      e.stopPropagation();
    }
  }, {
    key: "_screenToMap",
    value: function _screenToMap(e) {
      return this._getDrawSurface().screenToMap(e);
    }
  }, {
    key: "_screenToMapDragEventStep",
    value: function _screenToMapDragEventStep() {
      var _this8 = this;

      var e = null;
      return function (t) {
        if ("start" === t.action && (e = _this8._screenToMap(t.screenStart)), s(e)) return null;

        var i = _this8._screenToMap(t.screenEnd);

        return o(i) ? _objectSpread(_objectSpread({}, t), {}, {
          mapStart: e,
          mapEnd: i
        }) : null;
      };
    }
  }, {
    key: "_vertexWithinPointerDistance",
    value: function _vertexWithinPointerDistance(e, t) {
      var i = 25,
          r = this._mapToScreen(this.coordinateHelper.vectorToDehydratedPoint(e));

      return !!o(r) && b(r, t, i);
    }
  }]);

  return M;
}(t.EventedMixin(i));

function b(e, t, i) {
  var r = e.x - t.x,
      s = e.y - t.y;
  return r * r + s * s <= i;
}

e([d()], M.prototype, "defaultZ", void 0), e([d({
  value: u
})], M.prototype, "drawingMode", null), e([d({
  constructOnly: !0
})], M.prototype, "elevationDrawSurface", void 0), e([d({
  constructOnly: !0
})], M.prototype, "elevationInfo", void 0), e([d({
  constructOnly: !0
})], M.prototype, "geometryType", void 0), e([d({
  constructOnly: !0
})], M.prototype, "hasM", void 0), e([d({
  constructOnly: !0
})], M.prototype, "hasZ", void 0), e([d({
  constructOnly: !0
})], M.prototype, "manipulators", void 0), e([d({
  constructOnly: !0
})], M.prototype, "drawSurface", void 0), e([d({
  constructOnly: !0
})], M.prototype, "snappingManager", void 0), e([d({
  constructOnly: !0
})], M.prototype, "snappingVisualizer", void 0), e([d()], M.prototype, "snapToSceneEnabled", void 0), e([d({
  readOnly: !0
})], M.prototype, "updating", null), e([d({
  constructOnly: !0
})], M.prototype, "view", void 0), M = e([l("esri.views.draw.DrawOperation")], M);
export { M as DrawOperation };